
import Vue from 'vue'
import '@/assets/css/midAutumn.css'
import '@/assets/css/my-dark-theme.css'
import '@/assets/css/valentine.css'
import '@/assets/css/activity.css'
import '@/assets/css/invite.css'
import '@/assets/css/common.css'

import App from './App'
import ELEMENT from 'element-ui';
import router from './router'
// import '@/assets/font/font.css'
import svga from 'vue-svga'

Vue.use(svga)
import VueClipboard from 'vue-clipboard2'
// 全局引入Toast
import { Collapse, CollapseItem }  from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router'
import 'amfe-flexible';
import { Notify } from 'vant';
import 'vant/lib/notify/style';
import MarqueeLeft from './components/MarqueeLeft'
Vue.use(Notify);
Vue.prototype.bus = new Vue;
Vue.use(ELEMENT)
Vue.config.productionTip = false
Vue.use(VueClipboard)
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.component('MarqueeLeft', MarqueeLeft)
Vue.use(VueRouter)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js